import * as Error404 from '@/pages/error_page/_components/Error404'
import {
  ComponentImports,
  ComponentPath,
  InertiaRouter,
  AppComponent as BaseAppComponentType,
} from '../types'
import { getLayoutsForPath, getPageForPath } from '../shared'
import AppComponent from './AppComponent'

export default class OldInertiaRouter extends InertiaRouter {
  override init({ pages, layouts }: ComponentImports) {
    super.init({ pages, layouts })
  }

  async resolve(path: ComponentPath) {
    const page = getPageForPath(path, this.pages)?.()
    const layouts = Promise.all(getLayoutsForPath(path, this.layouts).map(fn => fn()))

    return {
      page: (await page) || Error404,
      layouts: await layouts,
    }
  }

  get AppComponent() {
    return AppComponent
  }
}

export type AppComponentType = BaseAppComponentType<
  Awaited<ReturnType<OldInertiaRouter['resolve']>>
>
